import React, { useState, useEffect } from 'react';
import { StripeElementsOptions } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { useAPI } from '../../../../clients/quipli-service/quipli-service-client';
import { useContext } from 'react';

import { StripeContext } from '../StripeContext';
import SetupPaymentForm from './setup-payment-form';
import { User } from '../../../../clients/quipli-service/user/user';
import { Spinner } from '../../../../components/spinner/spinner';
import { StripeCard } from '../../../../clients/quipli-service/payment/payment';
import { usePaymentApiV1 } from '../../../../clients/quipli-service/payment/payment-api-v1';

export const SetupPayment = ({
  userId,
  type,
  userCard,
  close,
  setCard,
}: {
  userId: number;
  type: 'bankAccount' | 'cardPresent' | 'card';
  userCard?: StripeCard;
  close?: () => void;
  setCard?: (stripeCard: StripeCard) => void;
}) => {
  const { getSetupIntentAdmin } = usePaymentApiV1();
  const { getUserById } = useAPI();
  const stripe = useContext(StripeContext);

  const [clientSecret, setClientSecret] = useState('');
  const [user, setUser] = useState<User>();
  const [setupIntent, setSetupIntent] = useState<string>();

  const init = async () => {
    getUserById(userId).then((user) => {
      setUser(user);
    });
    if (!stripe) {
      throw new Error('Stripe was not initialized');
    }
    await getSetupIntentAdmin(userId, 'card').then(({ setupIntent }) => {
      setClientSecret(setupIntent.client_secret!);
      setSetupIntent(setupIntent.id);
      return setupIntent.client_secret;
    });
  };

  useEffect(() => {
    init();
  }, []);

  const options: StripeElementsOptions = {
    clientSecret,
  };

  return (
    <div className="SetupPayment">
      {clientSecret && stripe && user && setupIntent ? (
        <Elements options={options} stripe={stripe}>
          <SetupPaymentForm
            user={user}
            clientSecret={clientSecret}
            close={close}
            userCard={userCard}
            setCard={setCard}
            type={type}
            setupIntentId={setupIntent}
          />
        </Elements>
      ) : (
        <Spinner />
      )}
    </div>
  );
};
